import React from 'react'
import '../App.css'
export default function Loder() {
  return (
    <div className="loader-container">
      <div className="loader"></div>
    </div>
  )
}
